import { render, staticRenderFns } from "./exaAllocateDiglog.vue?vue&type=template&id=2fb095ce&scoped=true"
import script from "./exaAllocateDiglog.vue?vue&type=script&lang=js"
export * from "./exaAllocateDiglog.vue?vue&type=script&lang=js"
import style0 from "./exaAllocateDiglog.vue?vue&type=style&index=0&id=2fb095ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb095ce",
  null
  
)

export default component.exports